'use strict';

import Register from "./components/Register.vue";
import RegisterButton from "./components/RegisterButton.vue";

export default class {

    constructor() {

        Vue.component('register', Register);
        Vue.component('register-button', RegisterButton);

        $(function() {
            $('*[data-role="register"]').on('click', function (e) {
                App.event.fire('registration.send', e.currentTarget);
                e.preventDefault();
            });
        });
    }
}
